import { render } from "./HolidayCard.vue?vue&type=template&id=0fd1450e&scoped=true"
import script from "./HolidayCard.vue?vue&type=script&lang=js"
export * from "./HolidayCard.vue?vue&type=script&lang=js"

import "./HolidayCard.vue?vue&type=style&index=0&id=0fd1450e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\travelsite-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd1450e"]])

export default __exports__